/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';

/**
 * 
 * @export
 * @interface InternalApiNote
 */
export interface InternalApiNote {
    /**
     * 
     * @type {number}
     * @memberof InternalApiNote
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiNote
     */
    content: string;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiNote
     */
    user?: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiNote
     */
    createdTime?: Date;
    /**
     * 
     * @type {number}
     * @memberof InternalApiNote
     */
    alertId?: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiNote
     */
    sanctionAlertId?: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiNote
     */
    bridgeAlertId?: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiNote
     */
    statusChangeId?: number;
}

/**
 * Check if a given object implements the InternalApiNote interface.
 */
export function instanceOfInternalApiNote(value: object): value is InternalApiNote {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiNoteFromJSON(json: any): InternalApiNote {
    return InternalApiNoteFromJSONTyped(json, false);
}

export function InternalApiNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiNote {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'content': json['content'],
        'user': json['user'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['user']),
        'createdTime': json['createdTime'] == null ? undefined : (new Date(json['createdTime'])),
        'alertId': json['alertId'] == null ? undefined : json['alertId'],
        'sanctionAlertId': json['sanctionAlertId'] == null ? undefined : json['sanctionAlertId'],
        'bridgeAlertId': json['bridgeAlertId'] == null ? undefined : json['bridgeAlertId'],
        'statusChangeId': json['statusChangeId'] == null ? undefined : json['statusChangeId'],
    };
}

export function InternalApiNoteToJSON(json: any): InternalApiNote {
    return InternalApiNoteToJSONTyped(json, false);
}

export function InternalApiNoteToJSONTyped(value?: InternalApiNote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'content': value['content'],
        'user': InternalApiUserBasicDetailsToJSON(value['user']),
        'createdTime': value['createdTime'] == null ? value['createdTime'] : value['createdTime'].toISOString(),
        'alertId': value['alertId'],
        'sanctionAlertId': value['sanctionAlertId'],
        'bridgeAlertId': value['bridgeAlertId'],
        'statusChangeId': value['statusChangeId'],
    };
}

